import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons'
import { faPauseCircle } from '@fortawesome/free-solid-svg-icons'

let globalAudio = null;

export const getGlobalAudio = () => globalAudio;

const useAudio = url => {
  const [audio] = useState(() => {
    const newAudio = new Audio(url);
    newAudio.preload = "none";
    globalAudio = newAudio;
    return newAudio;
  });
  const [playing, setPlaying] = useState(false);

  const toggle = () => setPlaying(!playing);

  useEffect(() => {
      playing ? audio.play() : audio.pause();
    },
    [playing]
  );

  useEffect(() => {
    audio.addEventListener('ended', () => setPlaying(false));
    return () => {
      audio.removeEventListener('ended', () => setPlaying(false));
    };
  }, []);

  return [playing, toggle, audio];
};

const Player = ({ url }) => {
  const [playing, toggle, audio] = useAudio(url);
  const [volume, setVolume] = useState(1);

  useEffect(() => {
    if (audio) {
      audio.volume = volume;
    }
  }, [volume, audio]);

  if (!playing) {
      var playingStatus = <FontAwesomeIcon size='3x' onClick={toggle} icon={faPlayCircle} color="#FF2C5E" />
  } else {
    var playingStatus = <FontAwesomeIcon size='3x' onClick={toggle} icon={faPauseCircle} color="#FF2C5E" />
  }

  return (
    <div>
     {playingStatus}
    </div>
  );
};

export default Player;